import People from '../people';

/**
 * Create the action
 */

const { thunk, request, success, error } = People.index((fetch) =>
  fetch.get('/dreams/people')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
